import Message from 'components/molecules/message';
import ParticipantItem from 'components/molecules/participantItem';
import {useTheme} from 'contexts/ThemeContext';
import {ConferenceUser} from 'models/ConferenceUser';
import React from 'react';
import {FlatList, ListRenderItemInfo, Text, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ParticipantsListProps {
  users: ConferenceUser[];
}

const ParticipantsList = (props: ParticipantsListProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const renderItem = (itemProps: ListRenderItemInfo<ConferenceUser>) => {
    return <ParticipantItem user={itemProps.item} />;
  };

  const Title = (
    <Text style={styles.title}>
      {strings.conferenceScreen.participants.title}
    </Text>
  );

  return (
    <View style={styles.container}>
      {theme.isWebSize && Title}
      <FlatList
        style={styles.flatList}
        renderItem={renderItem}
        data={props.users}
      />
    </View>
  );
};

export default ParticipantsList;
